import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { get } from 'local-storage'
import config from '@config'

const appHttpLink = createHttpLink({
    uri: `${config.API_BASEURL}graphql`,
})

const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = get<string>('token')
    // return the headers to the context so httpLink can read them 
    return {
        headers: {
            ...headers,
            Authorization: token ? `Bearer ${token}` : '',
        }
    }
})

const appClient = new ApolloClient({
    link: authLink.concat(appHttpLink),
    cache: new InMemoryCache()
})

export default appClient